import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "VideoCamera.svg",
  "use": "VideoCamera.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"VideoCamera.svg\"><path d=\"M56.7761,45.8685a2,2,0,0,1-2.18-.4336l-10-10a2,2,0,0,1-.586-1.4141v-4a2,2,0,0,1,.586-1.4141l10-10a2,2,0,0,1,3.414,1.4141v24A2,2,0,0,1,56.7761,45.8685ZM12.01,16.0208h24a6,6,0,0,1,6,6v20a6,6,0,0,1-6,6h-24a6,6,0,0,1-6-6v-20A6,6,0,0,1,12.01,16.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol